export const defaultCustomerData = {
    nbr: '',
    gender: 'Mme.',
    name: '',
    firstname: '',
    adresse: '',
    code: '',
    ville: '',
    type: '',
    acces: '',
    infosAidant: '',
    numAidant: '',
    num: '',
    repas: false,
    menage: false,
    bricolage: false,
    admin: false,
    courses: false,
    cheque: false,
    prelevement: false,
    virement: false,
    apa: false,
    alarme: false,
    contrat: false,
    mandat: false,
    dateString: '',
    firstDate: '',
    lastDate: '',
    comment: '',
    actif: true,
    origin: 'Internet',
    tourNum: '1',
  };